import { Button } from '@material-ui/core';
import React from "react";
import styled from '@emotion/styled';
import download_file from "../events/Pages/common_icons/download_file.svg";
import { FileQuestion } from '../api/types/questions';
import { Sizes, themeColor } from '../components/Theme';
import { useIntl } from 'react-intl';
import { downloadOrViewFile } from '../components/Common/downloadOrViewFile';

export const DownloadFile = ({file, questionId} : { questionId: string, file: FileQuestion }) => {
    const { formatMessage } = useIntl();

    return <DownloadButton
                title={file.filename}
                onClick={() => downloadOrViewFile(`/api/presidium-app/question/${questionId}/document/${file._id}`, file.filename)}>
        <img src={ download_file } alt="" />
        <Info>
            <Title>{file.filename}</Title>
            <Download>{formatMessage({ id: "service.download" })}</Download>
        </Info>
    </DownloadButton>
}

const DownloadButton = styled(Button)`
    box-sizing: content-box;
    padding: 5px;
    width: calc(100% - 10px);
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-radius: ${Sizes.geometry.borderRadius.pannel}px;
`;

const Info = styled.div`
    margin-left: 8px;
    width: 70%;
    text-align: left;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

const Download = styled.button`
    padding: 0;
    text-align: left;
    font: 400 14px "Ubuntu";
    color: ${themeColor(c => c.textGreyBasic)};
    background: none;
    border: none;
    cursor: pointer;
`;

const Title = styled.span`
    margin: 0;
    font: 300 14px "Ubuntu";
    text-transform: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;